// @ts-nocheck
import { getCookie } from "@insite/client-framework/Common/Cookies";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { GetLedgersApiParameter } from "@store/Framework/Services/LedgerService";
import loadLedgers from "@store/Framework/Store/Store/Data/Ledgers/Handlers/LoadLedgers";
import { useLedgersDataView } from "@store/Framework/Store/Store/Data/Ledgers/LedgersHooks";
import { useLedgersParameter } from "@store/Framework/Store/Store/Pages/BillingStatus/BillingStatusHooks";
import updateSearchFields from "@store/Framework/Store/Store/Pages/BillingStatus/Handlers/UpdateSearchFields";
import { useLocation } from "@toolkit/Framework/Store/Data/Pages/PageHooks";
import qs from "qs";
import React, { FC, useEffect } from "react";

const BillingStatusPage: FC<PageProps> = ({ id }) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const history = useHistory();
    const ledgersParameter = useLedgersParameter();
    const ledgersDataView = useLedgersDataView(ledgersParameter);
    let firstLoad = false;

    useEffect(() => {
        firstLoad = true;
        const pageSizeCookie = getCookie("BillingStatus-PageSize");
        const pageSize = pageSizeCookie ? parseInt(pageSizeCookie, 10) : undefined;
        if (location.search) {
            const getLedgersApiParameter = parseQueryString<GetLedgersApiParameter>(location.search);
            if (pageSize) {
                getLedgersApiParameter.pageSize = pageSize;
            }
            dispatch(updateSearchFields({ ...getLedgersApiParameter, type: "Replace" }));
        } else {
            dispatch(updateSearchFields({ type: "Initialize", pageSize }));
        }
    }, []);

    useEffect(() => {
        if (!firstLoad) {
            const queryString = qs.stringify(ledgersParameter);
            history.replace(`${location.pathname}${queryString !== "" ? `?${queryString}` : ""}`);
        }
    }, [ledgersParameter]);

    useEffect(() => {
        if (!firstLoad && !ledgersDataView.value && !ledgersDataView.isLoading) {
            dispatch(loadLedgers(ledgersParameter));
        }
    });

    return (
        <MobiusPage>
            <Zone contentId={id} zoneName="Content" />
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: BillingStatusPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
            {
                ...HorizontalRule,
            },
        ],
    },
};

export default pageModule;
